import secret from "../secret.json";

// 개발 서버에서만 화면 맨 위에 표시 바를 띄운다.
// 운영과 개발이 같은 코드를 쓰므로, 켜고 끄는 것은 secret.json 의 IS_DEVELOPMENT 하나다.
// 운영 secret.json 에는 이 키가 없어서 자동으로 꺼진다 (키를 추가하지 말 것).
//
// 이 파일은 teacher 와 student 두 앱에 똑같이 들어 있다. CRA 앱이 둘로 나뉘어 있어
// 공유할 방법이 없으니, 한쪽을 고치면 다른 쪽도 같이 고칠 것. 내용이 같아야 한다.

const BAR_HEIGHT_PX = 28;
const BAR_ELEMENT_ID = "dev-env-bar";

export function setupDevEnvBanner() {
  if (!secret.IS_DEVELOPMENT) return;
  if (document.getElementById(BAR_ELEMENT_ID)) return;

  // 탭이 여러 개 떠 있을 때 운영과 구분하려면 제목이 가장 빠르다.
  document.title = `[DEV] ${document.title}`;

  const style = document.createElement("style");
  style.textContent = `
    /* 100vh 를 쓰는 화면이 이 높이를 빼서 쓴다(styles/tokens.css 의 기본값은 0). */
    :root {
      --dev-bar-height: ${BAR_HEIGHT_PX}px;
    }
    body {
      padding-top: ${BAR_HEIGHT_PX}px !important;
    }
    #${BAR_ELEMENT_ID} {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: ${BAR_HEIGHT_PX}px;
      line-height: ${BAR_HEIGHT_PX}px;
      z-index: 2147483647;
      background-color: #b45309;
      background-image: repeating-linear-gradient(
        135deg,
        rgba(0, 0, 0, 0.14) 0 10px,
        rgba(0, 0, 0, 0) 10px 20px
      );
      color: #ffffff;
      /* body 글꼴을 물려받으면 앱마다 띠가 다르게 보인다. 직접 지정한다. */
      font-family: var(--font-family-base);
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.04em;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
      /* 정보 표시일 뿐이라 클릭을 가로채지 않는다. */
      pointer-events: none;
      user-select: none;
    }
  `;
  document.head.appendChild(style);

  const bar = document.createElement("div");
  bar.id = BAR_ELEMENT_ID;
  bar.textContent = `개발 서버 (${window.location.host})`;
  document.body.appendChild(bar);
}
